import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import {
  useTransition,
  animated,
} from 'react-spring';

import { removeFlashMessage } from '../helpers/FlashMessages';

const FlashMessage = ({ message, style }) => {
  let messageColor = message.type;
  if (!messageColor) {
    messageColor = 'info';
  }
  if (messageColor === 'download') {
    messageColor = 'info';
  }
  if (messageColor === 'update') {
    messageColor = 'warning';
  }

  return (
    <animated.div className="flash-message" style={style}>
      <Alert
        color={messageColor}
        isOpen={true}
        fade={false}
        toggle={message.type === 'update' ? undefined : () => {
          removeFlashMessage(message.id);
        }}
      >
        {message.text}
        <br />
        {message.button && (
          <Link
            to={message.button.url}
            className="alert-link"
            onClick={() => {
              removeFlashMessage(message.id);
            }}
          >
            {message.button.text}
          </Link>
        )}
      </Alert>
    </animated.div>
  );
};

FlashMessage.propTypes = {
  message: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
};

const FlashMessages = ({ messages }) => {
  const transitions = useTransition(messages, item => item.id, {
    config: {
      mass: 1,
      tension: 250,
      friction: 20,
    },
    from: { opacity: 0, right: -200 },
    enter: { opacity: 1, right: 10 },
    leave: { opacity: 0, right: -100 },
  });

  return (
    <div className="flash-messages">
      <div className="container">
        {transitions.map(({ item, key, props }) => (
          <FlashMessage
            key={key}
            message={item}
            style={props}
          />
        ))}
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  messages: state.App.messages,
});

FlashMessages.propTypes = {
  messages: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(FlashMessages);
